import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InterestedHost } from 'src/app/Services/WOWApi.Service';

@Component({
    selector: 'app-interested-host-info',
    templateUrl: './interested-host-info.component.html',
    styleUrls: ['./interested-host-info.component.css'],
    standalone: false
})
export class InterestedHostInfoComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public host: InterestedHost,
  ) { }

  ngOnInit(): void {
    console.log(this.host);
  }

}
